import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import { Navigate } from 'react-router-dom';

const HomeLayout = Loadable(lazy(() => import('layout/HomeLayout')));

const Homepage = Loadable(lazy(() => import('pages/Homepage')));
const ChatPage = Loadable(lazy(() => import('pages/ChatPage')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = (isLoggedIn) => ({
  path: '/',
  element: isLoggedIn ? <HomeLayout /> : <Navigate to="/login" />,
  children: [
    {
      path: '/',
      element: <Navigate to="/home" />
    },
    {
      path: '/home',
      element: <Homepage />
    },
    {
      path: '/chat/:slug',
      element: <ChatPage />
    },
    {
      path: '/chat',
      element: <ChatPage />
    },
    {
      path: '*',
      element: <div>No matching route</div>
    }
  ]
});

export default MainRoutes;
